import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Contacts } from '../../../model/contacts';
import { Groups } from '../../../model/groups';
import { GroupsService } from '../../../service/component_dependent/groups.service';
import { Data } from '../../../model/data';
import { ContactsService } from '../../../service/component_dependent/contacts/contacts.service';
import { NotifierService } from '../../../service/component_dependent/notifier.service';
import { JsonManager } from '../../../service/managers/json-manager';
import { StorageService } from '../../../service/managers/storage.service';
import { ContactGroup } from '../../../model/contact-group';
import { ContactGroupService } from '../../../service/component_dependent/contacts/contact-group.service';
import { ContactNumber } from '../../../model/contact-number';


@Component({
  selector: 'app-contacts-profile',
  templateUrl: './contacts-profile.component.html',
  styleUrls: ['./contacts-profile.component.scss']
})
export class ContactsProfileComponent implements OnInit {

  @ViewChild('modal') modal: ElementRef;

  @Output() onCreated: EventEmitter<void> = new EventEmitter<void>();

  public contact: Contacts;
  public contact_number: ContactNumber;

  protected readonly SALUTATIONS: string[];
  protected contactGroups: Array<ContactGroup>;
  protected groups: Groups[];
  protected groupsSelectedList = [];

  protected dropdownSettings = {};
  protected cDropdownList = [];
  protected contactList = [];

  protected mode: string;
  protected view_mode: string;

  constructor(private modalService: NgbModal,
    private groupsService: GroupsService,
    private contactsService: ContactsService,
    private notifierService: NotifierService,
    private storageService: StorageService,
    private contactGroupService: ContactGroupService) {

    this.SALUTATIONS = ['Mr.', 'Mrs.', 'Miss', 'Dr.', 'Ms.'];

    this.initComponents();
  }

  ngOnInit() {

  }

  public open() {
    this.clear();
    this.modalService.open(this.modal, { ariaLabelledBy: 'contactTitle', size: 'lg' });
    this.view_mode = "create";
  }

  public edit() {
    this.modalService.open(this.modal, { ariaLabelledBy: 'contactTitle', size: 'lg' });
    this.view_mode = "edit";
  }

  protected onFilterChange(keyword: string) {
    this.contactsService.getContacts(500, keyword, null).subscribe(
      (dataContacts: any) => {
        this.reassignVariablesContacts(dataContacts.data.data);
      },
      (errContacts: any) => {
      }
    );
  }


  protected onSubmit() {
    var contactGroup: ContactGroup;
    var reqObj;

    this.contact.added_by = this.storageService.getUser().id;
    this.contactGroups = new Array<ContactGroup>();

    // 'contact_id' => 'required',
    // 'number' => 'required',
    // 'country_code' => 'required',
    // 'type' => 'required'
    // $number = $request['number'];
    // $firstName = $request['first_name'];
    // $countryCode = $request['country_code'];
    // $type = ($request['type'] != null)? $request['type']: 'Mobile';
    // $query = ($request['contact_id'] != null)? $request['contact_id'] : null;

    // unset($request['number'], $request['country_code'], $request['type'], $request['contact_id']);

    reqObj = {
      'number': this.contact_number.number,
      'first_name': this.contact.first_name,
      'country_code': this.contact_number.country_code,
      'salutation': this.contact.salutation,
      'added_by': this.contact.added_by,
      'birthdate': this.contact.birthdate,
      'middle_name': this.contact.middle_name,
      'last_name': this.contact.last_name,
    }

    if (this.mode == "existing") {
      reqObj.contact_id = this.contactList[0].item_id;
    }

    if (this.view_mode == "edit") {
      reqObj.isEdit = "true";
      reqObj.contact_id = this.contact.id;
      reqObj.contact_number_id = this.contact_number.id;
    }

    this.contactsService.createContact(reqObj).subscribe(
      (dataContacts: any) => {

        if (this.groupsSelectedList.length > 0) {
          for (var i = 0; i < this.groupsSelectedList.length; i++) {
            contactGroup = new ContactGroup();
            contactGroup.contacts_id = dataContacts.data.id;
            contactGroup.groups_id = this.groupsSelectedList[i].id;
            contactGroup.owner = this.storageService.getUser().id;

            this.contactGroups.push(contactGroup);
          }

          this.contactGroupService.createContactGroup(this.contactGroups).subscribe(
            (dataCG: any) => {
              this.clearAndExitContactProfileModal();
              this.notifierService.showSuccess(dataContacts.message);
            }
          );
        } else {
          this.clearAndExitContactProfileModal();
          this.notifierService.showSuccess(dataContacts.message);
        }


      },
      (errorContacts: any) => {
        this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(errorContacts.error.message));
      },
    );
  }

  protected initComponents() {

    this.contact = new Contacts();
    this.contact_number = new ContactNumber();
    this.contact_number.country_code = "+63";
    this.contact.salutation = "Mr.";

    this.dropdownSettings = {
      singleSelection: true,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };

    this.groupsService.getGroups(null, null, null).subscribe(
      (dataGroups: any) => {
        this.reassignVariablesGroups(dataGroups.data);
      }
    );

    this.contactsService.getContacts(100, null, null).subscribe(
      (dataContacts: any) => {
        this.reassignVariablesContacts(dataContacts.data.data);
      },
      (errContacts: any) => {
      }
    );

  }

  protected setMode(mode: any) {
    this.mode = mode.nextId;
  }

  protected setCountryCode(countryCode: string) {
    this.contact_number.country_code = countryCode;
  }
  private reassignVariablesGroups(data: any) {
    var length;
    var obj;

    this.groups = new Array<Groups>();
    length = data.total;

    for (var i = 0; i < length; i++) {
      obj = data[i];
      this.groups.push(obj);
    }
  }

  private reassignVariablesContacts(data: any) {
    this.cDropdownList = [];

    for (var i = 0; i < data.length; i++) {
      this.cDropdownList.push({ item_id: data[i].id, item_text: (data[i].first_name + " " + data[i].last_name) });
    }
  }

  private clearAndExitContactProfileModal() {
    this.modalService.dismissAll();
    this.clear();
    this.onCreated.emit();
  }

  private clear() {
    this.initComponents();
    this.groupsSelectedList = [];
  }

}

